import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { AISidebar } from '@/ai/AISidebar';
import { TooltipProvider } from '@/components/ui/tooltip';
import { useGlobalStore } from '@/core/store';

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { sidebarCollapsed, aiSidebarOpen } = useGlobalStore();

  return (
    <TooltipProvider>
      <div className="flex h-screen overflow-hidden bg-background">
        {/* 左侧导航栏 */}
        <Sidebar />
        
        {/* 主内容区域 */}
        <div 
          className="flex flex-col flex-1 overflow-hidden transition-all duration-300"
          style={{
            marginLeft: sidebarCollapsed ? '64px' : '240px',
            marginRight: aiSidebarOpen ? '400px' : '0',
          }}
        >
          {/* 顶部导航 */}
          <Header />
          
          {/* 页面内容 */}
          <main className="flex-1 overflow-auto">
            {children}
          </main>
        </div>

        {/* AI 侧边栏 */}
        <AISidebar />
      </div>
    </TooltipProvider>
  );
}

